/**
 * 강사 상세 조회 커스텀 훅
 *
 * react-query를 사용하여 강사 상세 데이터를 fetch하고 캐싱
 * - 자동 리페칭 및 캐시 관리
 * - 로딩/에러 상태 관리
 */

import type { InstructorResponseDto } from "@repo/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getInstructorDetail } from "../api/instructorApi";

/**
 * 강사 상세 조회 훅
 *
 * @param instructorId - 조회할 강사 ID
 * @param options - react-query 옵션 (enabled 등)
 * @returns react-query의 useQuery 결과 (data, isLoading, isError 등)
 */
export const useInstructorDetail = (
  instructorId: number,
  options?: Omit<
    UseQueryOptions<InstructorResponseDto, Error>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery<InstructorResponseDto, Error>({
    queryKey: ["instructor", instructorId],
    queryFn: () => getInstructorDetail(instructorId),
    enabled: instructorId > 0 && (options?.enabled ?? true),
    staleTime: 1000 * 60 * 5, // 5분간 캐시 유지
    gcTime: 1000 * 60 * 10, // 10분간 가비지 컬렉션 유예
    ...options,
  });
};

